export default __webpack_public_path__ + "static/char-33-33269c122ff78f96b73451ddcf958d02.gif";